import { render, staticRenderFns } from "./costAdHistory.vue?vue&type=template&id=408d6216&scoped=true"
import script from "./costAdHistory.vue?vue&type=script&lang=js"
export * from "./costAdHistory.vue?vue&type=script&lang=js"
import style0 from "./costAdHistory.vue?vue&type=style&index=0&id=408d6216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d6216",
  null
  
)

export default component.exports